import { api, handleResponse, handleError } from "./apiServices";

export const requestDeleteAccountOtp = data =>
  api()
    .post("/api/user/auth/delete-account/request-otp", data)
    .then(handleResponse)
    .catch(handleError);

export const confirmDeleteAccount = data =>
  api()
    .post("/api/user/auth/delete-account/confirm", data)
    .then(handleResponse)
    .catch(handleError);
